import { useState } from "react";
import LoadingComponent from "../../../widgets/LoadingComponent";
import { Button, Card, FloatingLabel, Form, Modal } from "react-bootstrap";
import { FaEye, FaSearch } from "react-icons/fa";
import { formatDateddMMyyyyhhmm } from "../../../widgets/DateTime";
import { getData } from "../../../api/ApiRest";
import { useSelector } from "react-redux";

function GestionClientes() {
    const [loading, setLoading] = useState(false);
    const [dataBuscar, setDataBuscar] = useState({
        Desde: new Date().toISOString().split('T')[0],
        Hasta: new Date().toISOString().split('T')[0]
    });

    const [registros, setRegistros] = useState([]);
    const [infoProspecto, setInfoProspecto] = useState([]);

    const [prospecto, setProspecto] = useState([]);

    const [verInfoRegistro, setVerInfoRegistro] = useState({
        ModalVisible: false,
        Titulo: ''
    });

    const infoUser = useSelector((state) => state.auth);

    const buscarDocumentos = (event) => {
        event.preventDefault()
        setLoading(true);

        getData('api/Configuracion/Company/getDataProspectos', {
            fechaIni: dataBuscar.Desde,
            fechaFin: dataBuscar.Hasta
        }).then(response => {
            if (response.status) {
                setRegistros(response.datos);
                setInfoProspecto(response.infoProspecto);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    };

    const openNewTab = async (id, tipo) => {
        const AmbienteTae_Url = infoUser.AmbienteTae_Url;

        let UrlBase = AmbienteTae_Url +
            'api/Configuracion/Company/visualizarPdf?prospectoCompany=' + id + '&tipo=' + tipo;

        const token = infoUser.tokenSesion;

        const response = await fetch(UrlBase,
            {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Accept': 'application/json'
                }
            }
        );

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');
    }

    const cambiarEstado = (estado = '', id) => {
        setLoading(true);

        let comentario = '';

        ///Si estado es igual a cero, quiere decir que lo esta rechazando
        if (estado === '0') {
            comentario = prompt('Digita el motivo del rechazo');

            if (comentario === null) {
                setLoading(false);
                return;
            }
        }

        getData('api/Configuracion/Company/cambiarEstado', {
            id: id,
            estado: estado,
            comentario: comentario
        }).then(response => {
            if (response.status) {
                alert('Estado cambiado con éxito');

                setProspecto(prev => ({
                    ...prev,
                    estado: estado
                }));
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    return <div className='BodyComponent'>
        {<LoadingComponent Loading={loading} />}

        <Form onSubmit={buscarDocumentos}>
            <div className='row'>
                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="Desde"
                        label="Fecha Desde"
                        className="mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            required={true}
                            placeholder="Fecha Desde"
                            value={dataBuscar.Desde}
                            onChange={value => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    Desde: value.target.value
                                })
                            }}
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-3'>
                    <FloatingLabel
                        controlId="Hasta"
                        label="Fecha Hasta"
                        className="mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            required={true}
                            placeholder="Fecha Hasta"
                            value={dataBuscar.Hasta}
                            onChange={value => {
                                setDataBuscar({ ...dataBuscar, Hasta: value.target.value })
                            }}
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-1'>
                    <Button variant='primary' type='submit'>
                        <FaSearch size={'1rem'} />
                    </Button>
                </div>
            </div>

        </Form>

        <br />

        <div className="row">
            <div className='table-responsive mt-2'>
                <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado"></th>
                            <th className="estilo-encabezado">#</th>
                            <th className="estilo-encabezado">
                                # Solicitud
                            </th>
                            <th className="estilo-encabezado">
                                Cliente
                            </th>
                            <th className="estilo-encabezado">
                                Fecha registro
                            </th>
                            <th className="estilo-encabezado">
                                Ciudad
                            </th>
                            <th className="estilo-encabezado">
                                Estado
                            </th>
                            <th className="estilo-encabezado">
                                Tipo solicitud
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {registros.map((item, index) => (
                            <tr key={index} style={{ fontSize: 14 }}>
                                <td className="text-center">
                                    <Button type="button" variant="warning"
                                        style={{
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            fontSize: 12
                                        }}
                                        onClick={() => {
                                            setVerInfoRegistro({
                                                ModalVisible: true,
                                                Titulo: 'Solicitud # ' + item.solicitud
                                            });

                                            const data = infoProspecto.filter(x => x.id === item.id)[0];

                                            setProspecto(data);
                                        }}>
                                        <FaEye />
                                    </Button>
                                </td>
                                <td className="text-center">
                                    {index + 1}
                                </td>
                                <td className="text-center">
                                    {item.solicitud}
                                </td>
                                <td className="text-center">
                                    {item.cliente}
                                </td>
                                <td className="text-center">
                                    {formatDateddMMyyyyhhmm(item.fecha)}
                                </td>
                                <td className="text-center">
                                    {item.ciudad}
                                </td>
                                <td className="text-center">
                                    {item.estado}
                                </td>
                                <td className="text-center">
                                    {item.tipoSolicitud}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>

        <Modal
            size='xl'
            show={verInfoRegistro.ModalVisible}
            onShow={() => { }}
            onHide={() => {
                setVerInfoRegistro({
                    ModalVisible: false,
                    Titulo: ''
                });

                setProspecto([]);
            }}>
            <Modal.Header closeButton>
                <Modal.Title>{verInfoRegistro.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {<LoadingComponent Loading={loading} />}

                <div className="row">
                    <div className="col-md-3">
                        <FloatingLabel controlId="identificacion" label="Identificación">
                            <Form.Control
                                as="input"
                                type="text"
                                value={prospecto.identificacion}
                                readOnly
                            />
                            <Form.Control
                                as="input"
                                type="text"
                                value={prospecto.dv}
                                hidden
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-6">
                        <FloatingLabel controlId="razonsocial" label="Razón social">
                            <Form.Control
                                as="input"
                                type="text"
                                value={prospecto.razonsocial}
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="dirección" label="Dirección">
                            <Form.Control
                                as="input"
                                type="text"
                                value={prospecto.direccion}
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-md-4">
                        <FloatingLabel controlId="correo" label="Correo">
                            <Form.Control
                                as="input"
                                type="text"
                                value={prospecto.correo}
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-2">
                        <FloatingLabel controlId="telefono" label="Telefono">
                            <Form.Control
                                as="input"
                                type="text"
                                value={prospecto.telefono}
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="ciudad" label="Ciudad">
                            <Form.Control
                                as="input"
                                type="text"
                                value={prospecto.ciudad}
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId='plan'
                            label="Plan recomendado"
                            className="mb-2"
                        >
                            <Form.Control
                                as="input"
                                type="text"
                                value={prospecto.plan}
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                </div>
                <br />
                <div className='row'>
                    <div className='col-md-4'>
                        <Card>
                            <Card.Header className='bg-primary text-center text-white'>RUT</Card.Header>
                            <Card.Body>
                                {prospecto.rut === false ?
                                    <div>
                                        <h4 className='text-danger'>PENDIENTE</h4>
                                    </div>
                                    :
                                    <div className='text-center'>
                                        <button className='btn btn-sm btn-success'
                                            onClick={() => { openNewTab(prospecto.id, 'RUT') }}

                                        >
                                            VER RUT <FaEye size={'1rem'} />
                                        </button>
                                    </div>
                                }
                            </Card.Body>
                        </Card>
                    </div>

                    <div className='col-md-4'>
                        <Card>
                            <Card.Header className='bg-primary text-center text-white'>CAMARA Y COMERCIO</Card.Header>
                            <Card.Body>
                                {prospecto.camaraComercio === false ?
                                    <div>
                                        <h4 className='text-danger'>PENDIENTE</h4>
                                    </div>
                                    :
                                    <div className='text-center'>
                                        <button className='btn btn-sm btn-success'
                                            onClick={() => { openNewTab(prospecto.id, 'CCIO') }}

                                        >
                                            VER CAMARA Y CCIO <FaEye size={'1rem'} />
                                        </button>
                                    </div>
                                }
                            </Card.Body>
                        </Card>
                    </div>

                    <div className='col-md-4'>
                        <Card>
                            <Card.Header className='bg-primary text-center text-white'>CEDULA</Card.Header>
                            <Card.Body>
                                {prospecto.cedulaRepLegal === false ?
                                    <div>
                                        <h4 className='text-danger'>PENDIENTE</h4>
                                    </div>
                                    :
                                    <div className='text-center'>
                                        <button className='btn btn-sm btn-success'
                                            onClick={() => { openNewTab(prospecto.id, 'CEDULA') }}

                                        >
                                            VER CEDULA <FaEye size={'1rem'} />
                                        </button>
                                    </div>
                                }
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <br />
                <div className="row">
                    {prospecto.estado !== '0' && prospecto.estado !== "3" ? <div className="col-md-6 text-center">
                        <button title="Rechazar información" type="button" className="btn btn-sm btn-danger" onClick={() => cambiarEstado('0', prospecto.id)}>
                            Rechazar
                        </button>
                    </div> : null}

                    {prospecto.estado === "2" && prospecto.estado !== "0" ?
                        <div className="col-md-6 text-center">
                            <button title="Aprobar información" type="button" className="btn btn-sm btn-success" onClick={() => cambiarEstado('3', prospecto.id)}>
                                Aceptar
                            </button>
                        </div> : <>{prospecto.estado !== "0" && prospecto.estado !== "3" ? <div className="col-md-6 text-center">
                            <button title="Aprobar información" type="button" className="btn btn-sm btn-warning" onClick={() => cambiarEstado('2', prospecto.id)}>
                                Validar
                            </button>
                        </div> : null}</>}
                </div>

            </Modal.Body>
        </Modal>
    </div>

}

export default GestionClientes;